module.exports = __webpack_public_path__ + "static/media/spades.ed19d9a9.svg";